import React from 'react';
interface ToggleProps {
  id?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  size?: 'md' | 'sm';
}
export function Toggle({
  id,
  checked,
  onChange,
  label,
  size = 'md'
}: ToggleProps) {
  const track = size === 'md' ? 'h-6 w-11' : 'h-5 w-9';
  const knob = size === 'md' ? 'h-5 w-5' : 'h-4 w-4';
  const shift = size === 'md' ? 'translate-x-5' : 'translate-x-4';
  return <button id={id} type="button" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className={`relative inline-flex shrink-0 items-center rounded-full p-0.5 transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-connect-blue focus-visible:ring-offset-2 ${track} ${checked ? 'bg-connect-blue' : 'bg-gray-300'}`} data-id="element-458" data-mp="3pzaw7ntzn0t2">
      <span className={`${knob} rounded-full bg-white shadow transition-transform duration-150 ease-out ${checked ? shift : 'translate-x-0'}`} data-id="element-459" data-mp="1a73vrgq2mmfr" />
    </button>;
}